module.exports = __webpack_public_path__ + "static/media/Доклад за прилагане на политиката по възнагражденията.92a24f1f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2021/Доклад за прилагане на политиката по възнагражденията.pdf
// module id = 104
// module chunks = 0